import { render, staticRenderFns } from "./FormFlight.vue?vue&type=template&id=31cf074a&scoped=true&"
import script from "./FormFlight.vue?vue&type=script&lang=js&"
export * from "./FormFlight.vue?vue&type=script&lang=js&"
import style0 from "./FormFlight.vue?vue&type=style&index=0&id=31cf074a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31cf074a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabItem,VTabs,VTabsItems,VTabsSlider})
